// Mapeo de códigos de país ISO 2 letras a nombres completos en español
export const countryNames = {
    'AD': 'Andorra',
    'AE': 'Emiratos Árabes Unidos',
    'AF': 'Afganistán',
    'AG': 'Antigua y Barbuda',
    'AL': 'Albania',
    'AM': 'Armenia',
    'AR': 'Argentina',
    'AT': 'Austria',
    'AU': 'Australia',
    'AZ': 'Azerbaiyán',
    'BA': 'Bosnia y Herzegovina',
    'BB': 'Barbados',
    'BE': 'Bélgica',
    'BF': 'Burkina Faso',
    'BG': 'Bulgaria',
    'BH': 'Bahrein',
    'BI': 'Burundi',
    'BJ': 'Benín',
    'BN': 'Brunei',
    'BO': 'Bolivia',
    'BR': 'Brasil',
    'BS': 'Bahamas',
    'BT': 'Bután',
    'CA': 'Canadá',
    'CH': 'Suiza',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Colombia',
    'CR': 'Costa Rica',
    'CU': 'Cuba',
    'CY': 'Chipre',
    'CZ': 'República Checa',
    'DE': 'Alemania',
    'DK': 'Dinamarca',
    'DO': 'República Dominicana',
    'DZ': 'Argelia',
    'EC': 'Ecuador',
    'EE': 'Estonia',
    'EG': 'Egipto',
    'ES': 'España',
    'FI': 'Finlandia',
    'FR': 'Francia',
    'GB': 'Reino Unido',
    'GR': 'Grecia',
    'GT': 'Guatemala',
    'HK': 'Hong Kong',
    'HN': 'Honduras',
    'HR': 'Croacia',
    'HU': 'Hungría',
    'ID': 'Indonesia',
    'IE': 'Irlanda',
    'IN': 'India',
    'IQ': 'Irak',
    'IR': 'Irán',
    'IL': 'Israel',
    'IS': 'Islandia',
    'IT': 'Italia',
    'JO': 'Jordania',
    'JP': 'Japón',
    'KE': 'Kenia',
    'KR': 'Corea del Sur',
    'KW': 'Kuwait',
    'KZ': 'Kazajstán',
    'LA': 'Laos',
    'LB': 'Líbano',
    'LI': 'Liechtenstein',
    'LK': 'Sri Lanka',
    'LT': 'Lituania',
    'LU': 'Luxemburgo',
    'LV': 'Letonia',
    'MA': 'Marruecos',
    'MC': 'Mónaco',
    'MD': 'Moldavia',
    'ME': 'Montenegro',
    'MG': 'Madagascar',
    'MK': 'Macedonia',
    'MT': 'Malta',
    'MX': 'México',
    'MY': 'Malasia',
    'NL': 'Países Bajos',
    'NO': 'Noruega',
    'NZ': 'Nueva Zelanda',
    'OM': 'Omán',
    'PA': 'Panamá',
    'PH': 'Filipinas',
    'PE': 'Perú',
    'PL': 'Polonia',
    'PT': 'Portugal',
    'RO': 'Rumania',
    'RU': 'Rusia',
    'RW': 'Ruanda',
    'SA': 'Arabia Saudita',
    'SD': 'Sudán',
    'SE': 'Suecia',
    'SG': 'Singapur',
    'SI': 'Eslovenia',
    'SK': 'Eslovaquia',
    'SV': 'El Salvador',
    'SY': 'Siria',
    'TH': 'Tailandia',
    'TN': 'Túnez',
    'TR': 'Turquía',
    'TT': 'Trinidad y Tobago',
    'TW': 'Taiwán',
    'TZ': 'Tanzania',
    'US': 'Estados Unidos',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistán',
    'VA': 'Vaticano',
    'VC': 'San Vicente y las Granadinas',
    'VN': 'Vietnam',
    'VU': 'Vanuatu',
    'WS': 'Samoa',
    'XK': 'Kosovo',
    'YE': 'Yemen',
    'ZA': 'Sudáfrica',
    'ZW': 'Zimbabue',
    'AI': 'Anguilla',
    'AQ': 'Antártida',
    'AW': 'Aruba',
    'AX': 'Islas Åland',
    'AS': 'Samoa Americana',
    'BD': 'Bangladesh',
    'BL': 'San Bartolomé',
    'BM': 'Bermuda',
    'BQ': 'Caribe Neerlandés',
    'BV': 'Isla Bouvet',
    'BW': 'Botswana',
    'BY': 'Bielorrusia',
    'CC': 'Islas Cocos (Keeling)',
    'CD': 'República Democrática del Congo',
    'CF': 'República Centroafricana',
    'CG': 'República del Congo',
    'CI': 'Costa de Marfil',
    'CK': 'Islas Cook',
    'CM': 'Camerún',
    'CV': 'Cabo Verde',
    'CW': 'Curazao',
    'CX': 'Isla Christmas',
    'DJ': 'Yibuti',
    'DM': 'Dominica',
    'EH': 'Sáhara Occidental',
    'ER': 'Eritrea',
    'ET': 'Etiopía',
    'FJ': 'Fiyi',
    'FK': 'Islas Malvinas',
    'FM': 'Micronesia',
    'FO': 'Islas Feroe',
    'GA': 'Gabón',
    'GD': 'Granada',
    'GE': 'Georgia',
    'GF': 'Guayana Francesa',
    'GG': 'Guernsey',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GL': 'Groenlandia',
    'GM': 'Gambia',
    'GN': 'Guinea',
    'GQ': 'Guinea Ecuatorial',
    'GS': 'Islas Georgia del Sur y Sandwich del Sur',
    'GY': 'Guyana',
    'HM': 'Islas Heard y McDonald',
    'HT': 'Haití',
    'IM': 'Isla de Man',
    'JE': 'Jersey',
    'JM': 'Jamaica',
    'KG': 'Kirguistán',
    'KH': 'Camboya',
    'KI': 'Kiribati',
    'KM': 'Comoras',
    'KN': 'San Cristóbal y Nieves',
    'KP': 'Corea del Norte',
    'KY': 'Islas Caimán',
    'LC': 'Santa Lucía',
    'LR': 'Liberia',
    'LS': 'Lesoto',
    'LY': 'Libia',
    'MH': 'Islas Marshall',
    'ML': 'Malí',
    'MM': 'Birmania',
    'MN': 'Mongolia',
    'MO': 'Macao',
    'MP': 'Islas Marianas del Norte',
    'MR': 'Mauritania',
    'MS': 'Montserrat',
    'MU': 'Mauricio',
    'MV': 'Maldivas',
    'MW': 'Malaui',
    'MZ': 'Mozambique',
    'NA': 'Namibia',
    'NC': 'Nueva Caledonia',
    'NE': 'Níger',
    'NF': 'Isla Norfolk',
    'NG': 'Nigeria',
    'NI': 'Nicaragua',
    'NP': 'Nepal',
    'NR': 'Nauru',
    'NU': 'Niue',
    'PF': 'Polinesia Francesa',
    'PG': 'Papúa Nueva Guinea',
    'PK': 'Pakistán',
    'PM': 'San Pedro y Miquelón',
    'PN': 'Islas Pitcairn',
    'PR': 'Puerto Rico',
    'PS': 'Palestina',
    'PW': 'Palaos',
    'PY': 'Paraguay',
    'QA': 'Catar',
    'RE': 'Reunión',
    'SC': 'Seychelles',
    'SH': 'Santa Elena',
    'SJ': 'Svalbard y Jan Mayen',
    'SL': 'Sierra Leona',
    'SM': 'San Marino',
    'SN': 'Senegal',
    'SO': 'Somalia',
    'SR': 'Surinam',
    'SS': 'Sudán del Sur',
    'ST': 'Santo Tomé y Príncipe',
    'SX': 'Sint Maarten',
    'SZ': 'Esuatini',
    'TC': 'Islas Turcas y Caicos',
    'TD': 'Chad',
    'TF': 'Territorios Australes Franceses',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TL': 'Timor Oriental',
    'TM': 'Turkmenistán',
    'TO': 'Tonga',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UM': 'Islas Ultramarinas de EE.UU.',
    'WF': 'Wallis y Futuna',
    'VE': 'Venezuela'
};

/**
 * Obtiene el nombre completo de un país en español a partir de su código ISO
 * @param {string} countryCode - Código ISO de 2 letras del país
 * @returns {string} - Nombre completo del país en español o el código si no se encuentra
 */
export const getCountryName = (countryCode) => {
    if (!countryCode) return 'No especificado';
    return countryNames[countryCode.toUpperCase()] || countryCode;
};

const normalizeText = (value) => {
    if (!value) return '';
    return value
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
};

const countryNameToCode = Object.entries(countryNames).reduce((acc, [code, name]) => {
    acc[normalizeText(name)] = code;
    return acc;
}, {});

/**
 * Devuelve el código ISO-2 a partir de un código o nombre de país.
 * @param {string} value Código ISO-2 o nombre completo del país.
 * @returns {string|null}
 */
export const getCountryCode = (value) => {
    if (!value) return null;
    const input = value.toString().trim();
    if (/^[A-Za-z]{2}$/.test(input)) {
        const normalizedCode = input.toUpperCase();
        return countryNames[normalizedCode] ? normalizedCode : null;
    }

    return countryNameToCode[normalizeText(input)] || null;
};

/**
 * Opciones ordenadas para selectores de país.
 */
export const countryOptions = Object.entries(countryNames)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name, 'es'));
